"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIGNIN_WITH_FACEBOOK_AUTHENTICATED = exports.SIGNIN_WITH_FACEBOOK = exports.SIGNIN_WITH_GOOGLE_AUTHENTICATED = exports.SIGNIN_WITH_GOOGLE = exports.AUTH_TOKEN = exports.SHOW_LOADING = exports.HIDE_AUTH_MESSAGE = exports.SHOW_AUTH_MESSAGE = exports.SIGNUP_SUCCESS = exports.SIGNUP = exports.SIGNOUT_SUCCESS = exports.SIGNOUT = exports.AUTHENTICATED = exports.SIGNIN = void 0;
var SIGNIN = 'SIGNIN';
exports.SIGNIN = SIGNIN;
var AUTHENTICATED = 'AUTHENTICATED';
exports.AUTHENTICATED = AUTHENTICATED;
var SIGNOUT = 'SIGNOUT';
exports.SIGNOUT = SIGNOUT;
var SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS';
exports.SIGNOUT_SUCCESS = SIGNOUT_SUCCESS;
var SIGNUP = 'SIGNUP';
exports.SIGNUP = SIGNUP;
var SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
exports.SIGNUP_SUCCESS = SIGNUP_SUCCESS;
var SHOW_AUTH_MESSAGE = 'SHOW_AUTH_MESSAGE';
exports.SHOW_AUTH_MESSAGE = SHOW_AUTH_MESSAGE;
var HIDE_AUTH_MESSAGE = 'HIDE_AUTH_MESSAGE';
exports.HIDE_AUTH_MESSAGE = HIDE_AUTH_MESSAGE;
var SHOW_LOADING = 'SHOW_LOADING';
exports.SHOW_LOADING = SHOW_LOADING;
var AUTH_TOKEN = 'auth_token';
exports.AUTH_TOKEN = AUTH_TOKEN;
var SIGNIN_WITH_GOOGLE = 'SIGNIN_WITH_GOOGLE';
exports.SIGNIN_WITH_GOOGLE = SIGNIN_WITH_GOOGLE;
var SIGNIN_WITH_GOOGLE_AUTHENTICATED = 'SIGNIN_WITH_GOOGLE_AUTHENTICATED';
exports.SIGNIN_WITH_GOOGLE_AUTHENTICATED = SIGNIN_WITH_GOOGLE_AUTHENTICATED;
var SIGNIN_WITH_FACEBOOK = 'SIGNIN_WITH_FACEBOOK';
exports.SIGNIN_WITH_FACEBOOK = SIGNIN_WITH_FACEBOOK;
var SIGNIN_WITH_FACEBOOK_AUTHENTICATED = 'SIGNIN_WITH_FACEBOOK_AUTHENTICATED';
exports.SIGNIN_WITH_FACEBOOK_AUTHENTICATED = SIGNIN_WITH_FACEBOOK_AUTHENTICATED;